import { ASSETS } from "@/lib/api";

export const Footer = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="relative bg-black border-t border-yellow-400/15 pt-20 pb-10 overflow-hidden" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="flex flex-wrap items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <img src={ASSETS.logo} alt="RGP" className="h-14 w-14 rounded-full object-cover" />
            <div>
              <p className="font-display font-extrabold uppercase text-xl">Revolutionary Goans Party</p>
              <p className="font-mono-rgp text-[10px] uppercase tracking-[0.25em] text-yellow-400">For Goa. For Goans. For Our Future.</p>
            </div>
          </div>
          <nav className="flex flex-wrap gap-6">
            {[["about", "About"], ["agenda", "Agenda"], ["constitution", "Constitution"], ["committee", "Committee"], ["membership", "Join"], ["donate", "Donate"], ["contact", "Contact"]].map(([id, label]) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => go(id)} className="font-mono-rgp text-[11px] uppercase tracking-[0.2em] text-zinc-500 hover:text-yellow-400 transition-colors">
                {label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-4 text-xs text-zinc-600">
          <p>© {new Date().getFullYear()} Revolutionary Goans Party. All rights reserved.</p>
          <p>For Goa. For Goans. For Our Future.</p>
        </div>
      </div>
    </footer>
  );
};
